import React, { Fragment, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// import { Link, withRouter } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import {
    Grid,
    Typography,
    Box,
    Avatar,
    Tooltip,
    IconButton,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';

import { StackDateforDisplay } from '../../actions/app';
import { useNotificationCardFocus } from '../../utils/notificationDeepLink';
import { artistViewedHostOffer, deleteArtistEvent } from '../../actions/event';

import EventDetails from './EventDetails';

import Button from '../layout/SvgButton';
// import HostProfile from '../hosts/HostProfile';
// import { relativeTimeRounding } from 'moment';
import ArtistDashboardBookingOffers from './ArtistDashboardBookingOffers';

import DeleteIcon from '@mui/icons-material/Delete';
import EditArtistEvent from './EditArtistEvent';
import ArtistReviewsHost from '../artists/ArtistReviewsHost';
import CancelEventBtnDialog from './CancelEventBtnDialog';

const ArtistDashboardEventCard = ({
    thisEvent,
    artistViewedHostOffer,
    deleteArtistEvent,
    eventEditDrawer,
    artistMe,
    auth,
    onCancelStarted,
}) => {
    //console.log('ArtistDashboardEventCard thisEvent:', thisEvent);

    //Booking Details Dialog Functions
    const [eventDetailsDialogOpen, setEventDetailsDialogOpen] = useState(false);

    const [wantsToBook, setWantsToBook] = useState(false);
    const location = useLocation();
    const { focused: notificationFocus, releaseFocus: releaseNotificationFocus } =
        useNotificationCardFocus(thisEvent && thisEvent._id);

    const eventDetailsDialogHandleClose = () => {
        setDialogDetailsState({});
        setEventDetailsDialogOpen(false);
        setWantsToBook(false);
    };

    const [eventDialogDetails, setDialogDetailsState] = useState({});

    useEffect(() => {
        //console.log('eventDialogDetails', eventDialogDetails);
        setEventDetailsDialogOpen(true);
    }, [eventDialogDetails]);

    const handleEventBtnClick = (theOffer) => {
        setDialogDetailsState(theOffer);
    };
    //End of Dialog Functions

    const hasAcceptedHostOffer =
        Array.isArray(thisEvent.offersFromHosts) &&
        thisEvent.offersFromHosts.some(
            (offer) => offer && offer.status === 'ACCEPTED'
        );

    const showEventPageActions =
        thisEvent.createdBy === 'ARTIST' &&
        thisEvent.status === 'CONFIRMED' &&
        hasAcceptedHostOffer;

    //for animated border
    const dashboardEventCardRef = useRef(null);
    const [eventCardHeight, setHeight] = useState(0);
    const [eventCardWidth, setWidth] = useState(0);
    useEffect(() => {
        setHeight(dashboardEventCardRef.current.offsetHeight);
        setWidth(dashboardEventCardRef.current.offsetWidth);
    }, []);

    useEffect(() => {
        if (thisEvent._id === eventEditDrawer) {
            if (dashboardEventCardRef.current) {
                dashboardEventCardRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
            //console.log('eventEditDrawer', eventEditDrawer);
        }
    }, [eventEditDrawer]);

    useEffect(() => {
        const eventID = new URLSearchParams(location.search).get('eventID');
        if (!eventID || String(thisEvent._id) !== String(eventID)) return;
        const timer = setTimeout(() => {
            if (dashboardEventCardRef.current) {
                dashboardEventCardRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }, 400);
        return () => clearTimeout(timer);
    }, [thisEvent._id, location.search, location.key]);

    const [iDeclined, setiDeclined] = useState(false);

    useEffect(() => {
        if (
            thisEvent.declinedArtists &&
            thisEvent.declinedArtists.length > -1
        ) {
            setiDeclined(
                thisEvent.declinedArtists.filter((declinedArtist) => {
                    // console.log(
                    //     'declinedArtist.artist | prefArtist._id',
                    //     declinedArtist.artist +
                    //         ' | ' +
                    //         prefArtist._id
                    // );
                    return declinedArtist.artist === artistMe._id;
                }).length > 0
            );
            // console.log('declined', declined);
        }
    }, [thisEvent.declinedArtists]);

    const [hostsDeclined, setHostsDeclined] = useState(0);

    useEffect(() => {
        if (thisEvent.hostsInReach && thisEvent.hostsInReach.length > 0) {
            setHostsDeclined(
                thisEvent.hostsInReach.filter((hostInReach) => {
                    if (hostInReach.declined) {
                        return 1;
                    } else return 0;
                }).length
            );
        }
    }, [thisEvent.hostsInReach]);

    return (
        <>
            <Tooltip
                arrow={true}
                followCursor={true}
                title={
                    iDeclined ? (
                        <div
                            style={{
                                fontFamily: 'var(--secondary-font)',
                                color: '#fff',
                                textAlign: 'center',
                            }}
                        >
                            You declined this offer.
                        </div>
                    ) : (
                        ''
                    )
                }
            >
                <Grid
                    container
                    item
                    className={
                        (thisEvent._id === eventEditDrawer
                            ? 'ArtistDashboardEventCard bookingWhen mostRecent'
                            : 'ArtistDashboardEventCard bookingWhen') +
                        (notificationFocus ? ' notificationFocus' : '')
                    }
                    key={thisEvent._id}
                    // direction="row"
                    // sm={5.5}
                    // xs={12}
                    size={{ xs: 12, sm: 12 }}
                    id={thisEvent._id ? String(thisEvent._id) : undefined}
                    ref={dashboardEventCardRef}
                    sx={{
                        backgroundColor: 'rgba(0,0,0,0.35)',
                        '&:hover': {},
                        padding: '16px',
                        margin: '4px',
                        color: 'var(--light-color)',
                        // justifyContent: 'space-between',
                        justifyContent: 'flex-start',
                        flexWrap: 'nowrap',
                        opacity: iDeclined ? '0.6' : '1',
                        // border:
                        //     thisEvent._id === eventEditDrawer
                        //         ? '1px solid var(--dark-color)'
                        //         : '1px solid transparent',
                        // transition: 'all .8s cubic-bezier(0.23, 1, 0.32, 1) 0ms',
                        // transitionDelay: '.8s',
                        // boxShadow:
                        //     thisEvent._id === eventEditDrawer
                        //         ? '0 0 5px 0px var(--dark-color)'
                        //         : ' 0 0 0 0 transparent',
                        position: 'relative',
                        filter: iDeclined ? 'grayscale(100%)' : '',
                        // flexDirection: { xs: 'column', sm: 'row' },
                        flexDirection:
                            thisEvent.status === 'CONFIRMED' &&
                            new Date(thisEvent.bookingWhen) < new Date()
                                ? 'column'
                                : 'row',
                        backgroundImage:
                            thisEvent.status === 'CANCELED'
                                ? 'repeating-linear-gradient(45deg, rgb(255 0 0 / 10%) 5px, rgb(255 0 0 / 10%) 15px, transparent 15px, transparent 30px)'
                                : 'none',
                        maskImage:
                            thisEvent.status === 'CANCELED'
                                ? 'radial-gradient(black 50%, transparent)'
                                : 'none',
                    }}
                >
                    <svg
                        width={eventCardWidth}
                        height={eventCardHeight}
                        className="eventCardSvgBorder"
                        style={{
                            pointerEvents: 'none',
                        }}
                    >
                        <polygon
                            points={
                                '0,' +
                                eventCardHeight +
                                ' 0,0 ' +
                                eventCardWidth +
                                ',0 ' +
                                eventCardWidth +
                                ',' +
                                eventCardHeight +
                                ''
                            }
                            className={
                                thisEvent._id === eventEditDrawer
                                    ? 'borderEffect'
                                    : ''
                            }
                            style={{
                                strokeDasharray: `${eventCardHeight * 2} ${
                                    eventCardHeight * 2 + eventCardWidth * 2
                                }`,
                                strokeDashoffset:
                                    thisEvent._id === eventEditDrawer
                                        ? `${eventCardHeight * 2}`
                                        : `${
                                              eventCardHeight * 2 +
                                              eventCardWidth * 3
                                          }`,
                            }}
                        />
                    </svg>

                    <Grid
                        container
                        item
                        direction="row"
                        // alignItems="center"
                        className="dateLocationForBookingWrapper"
                        sx={{
                            // flexWrap: 'nowrap'
                            justifyContent: {
                                xs: 'center',
                                sm: 'space-evenly',
                            },
                            margin: { xs: '10px auto', sm: '0px auto' },
                            width: '100%',
                        }}
                        // xs={12}
                        size={{ xs: 12 }}
                    >
                        {thisEvent.createdBy === 'HOST' &&
                            thisEvent.offersFromHosts &&
                            thisEvent.offersFromHosts.length > 0 &&
                            thisEvent.offersFromHosts[0] &&
                            thisEvent.offersFromHosts[0].host &&
                            thisEvent.offersFromHosts[0].host.profileImg && (
                                <Grid
                                    className="feoyAvatarGridItem"
                                    item
                                    sx={{
                                        // width: '100%',
                                        flexBasis: { xs: '80px', sm: '130px' },
                                        flexShrink: '3',
                                        flexGrow: '2',
                                    }}
                                    size={{ xs: 12 }}
                                >
                                    <Box
                                        className="squareImgInACircle"
                                        sx={{
                                            height: 'auto',
                                            width: 'auto',
                                            // maxHeight: { xs: '100px', sm: '130px' },
                                            maxHeight: '130px',
                                            // maxWidth: { xs: '100px', sm: '130px' },
                                            maxWidth: '130px',
                                            borderRadius: '50%',
                                            overflow: 'hidden',
                                            backgroundImage: `url("${thisEvent.offersFromHosts[0].host.profileImg}")`,
                                            backgroundPosition: '50% 25%',
                                            backgroundSize: 'cover',
                                            padding: '4px',
                                            backgroundClip: 'content-box',
                                            border: '1px solid var(--primary-color)',
                                            margin: {
                                                xs: '0 auto',
                                                sm: '0 8px 0 0',
                                            },
                                            aspectRatio: '1 / 1',
                                        }}
                                    ></Box>
                                </Grid>
                            )}

                        <Grid
                            container
                            item
                            direction="column"
                            alignItems="flex-start"
                            className="dateLocationForBooking"
                            sx={{
                                flexBasis: {
                                    xs: 'none', //'calc(100% - 80px)',
                                    sm: 'calc(100% - 130px)',
                                },
                                flexGrow: '1',
                            }}
                            // xs={8}
                            // sm={8}
                            size={{ xs: 12 }}
                        >
                            {thisEvent.createdBy === 'HOST' &&
                                thisEvent.offersFromHosts &&
                                thisEvent.offersFromHosts.length > 0 &&
                                thisEvent.offersFromHosts[0] &&
                                thisEvent.offersFromHosts[0].host &&
                                thisEvent.offersFromHosts[0].host
                                    .profileImg && (
                                    <Grid item container className="hostName">
                                        <Typography component="h2">
                                            {
                                                thisEvent.offersFromHosts[0]
                                                    .host.firstName
                                            }{' '}
                                            {
                                                thisEvent.offersFromHosts[0]
                                                    .host.lastName
                                            }{' '}
                                        </Typography>
                                    </Grid>
                                )}
                            <Grid
                                container
                                item
                                direction="row"
                                alignItems="center"
                                className="feoyDateLocation"
                                sx={{
                                    flexWrap: 'nowrap',
                                }}
                                size={{ xs: 12 }}
                                spacing={1.5}
                                // xs={8}
                                // sm={8}
                            >
                                <Grid
                                    item
                                    sx={
                                        {
                                            // width: '55px',
                                        }
                                    }
                                >
                                    <StackDateforDisplay
                                        date={thisEvent.bookingWhen}
                                    ></StackDateforDisplay>
                                </Grid>
                                <Grid
                                    item
                                    // xs={9}
                                    size={{ xs: 12 }}
                                    className="cityStateAndHostsDeclined"
                                    sx={
                                        {
                                            // marginLeft: '8px',
                                        }
                                    }
                                >
                                    <Grid
                                        container
                                        sx={{ flexDirection: 'row' }}
                                        size={{ xs: 12 }}
                                    >
                                        <Grid
                                            item
                                            className="cityST"
                                            sx={{
                                                fontSize: {
                                                    xs: '1.2em',
                                                    sm: '1.5em',
                                                },
                                                // marginLeft: '8px',
                                                lineHeight: '1.5',
                                            }}
                                        >
                                            {thisEvent.bookingWhere.city +
                                                ', ' +
                                                thisEvent.bookingWhere.state}
                                        </Grid>
                                        {thisEvent.status === 'PENDING' &&
                                            thisEvent.createdBy === 'ARTIST' &&
                                            thisEvent.hostsInReach &&
                                            thisEvent.hostsInReach.length >
                                                0 && (
                                                <>
                                                    {thisEvent.hostsInReach
                                                        .length === 1 ? (
                                                        <Grid
                                                            item
                                                            className="hostsDeclined"
                                                            sx={{
                                                                fontSize: {
                                                                    xs: '.8em',
                                                                },
                                                                margin: '6px 8px 0 8px',
                                                                color: 'var(--primary-color)',
                                                            }}
                                                        >
                                                            (
                                                            {hostsDeclined === 1
                                                                ? 'The only host in the area declined'
                                                                : 'The host in the area hasn’t declined, yet'}
                                                            )
                                                        </Grid>
                                                    ) : thisEvent.hostsInReach
                                                          .length ===
                                                      hostsDeclined ? (
                                                        <Grid
                                                            item
                                                            className="hostsDeclined"
                                                            sx={{
                                                                fontSize: {
                                                                    xs: '.8em',
                                                                },
                                                                margin: '6px 8px 0 8px',
                                                                color: 'var(--primary-color)',
                                                            }}
                                                        >
                                                            (Each of the{' '}
                                                            {
                                                                thisEvent
                                                                    .hostsInReach
                                                                    .length
                                                            }{' '}
                                                            hosts in the area
                                                            declined)
                                                        </Grid>
                                                    ) : (
                                                        <Grid
                                                            item
                                                            className="hostsDeclined"
                                                            sx={{
                                                                fontSize: {
                                                                    xs: '.8em',
                                                                },
                                                                margin: '6px 8px 0 8px',
                                                                color: 'var(--primary-color)',
                                                            }}
                                                        >
                                                            ({hostsDeclined} of{' '}
                                                            {
                                                                thisEvent
                                                                    .hostsInReach
                                                                    .length
                                                            }{' '}
                                                            hosts in the area
                                                            declined, so far)
                                                        </Grid>
                                                    )}
                                                </>
                                            )}
                                    </Grid>

                                    {thisEvent.createdBy === 'ARTIST' &&
                                    thisEvent.offersFromHosts &&
                                    thisEvent.offersFromHosts.length > 0 ? (
                                        <Grid
                                            item
                                            container
                                            className="artistOffersFromHosts"
                                            sx={{
                                                width: '100%',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {thisEvent.offersFromHosts
                                                .filter((e) => e) //.filter(e => e) to remove any null values
                                                .map((thisOffer, idx) => (
                                                    <ArtistDashboardBookingOffers
                                                        thisOffer={thisOffer}
                                                        thisEvent={thisEvent}
                                                        onNotificationDialogClose={
                                                            releaseNotificationFocus
                                                        }
                                                    ></ArtistDashboardBookingOffers>
                                                ))}
                                            {showEventPageActions && (
                                                    <Grid
                                                        item
                                                        sx={{
                                                            marginLeft: 'auto',
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            gap: '4px',
                                                        }}
                                                    >
                                                        <Link
                                                            to={`/events/${thisEvent._id}`}
                                                            style={{
                                                                textDecoration:
                                                                    'none',
                                                            }}
                                                        >
                                                            <Button btnwidth="160">
                                                                Event Page
                                                            </Button>
                                                        </Link>
                                                        <CancelEventBtnDialog
                                                            theEvent={thisEvent}
                                                            canceledBy={'ARTIST'}
                                                            inline
                                                            onCancelStarted={
                                                                onCancelStarted
                                                            }
                                                        ></CancelEventBtnDialog>
                                                    </Grid>
                                                )}
                                        </Grid>
                                    ) : thisEvent.createdBy === 'ARTIST' ? (
                                        <Grid
                                            item
                                            container
                                            className="artistOffersFromHosts"
                                        >
                                            <EditArtistEvent
                                                theEvent={thisEvent}
                                            ></EditArtistEvent>
                                        </Grid>
                                    ) : thisEvent.createdBy === 'HOST' &&
                                      thisEvent.confirmedHost ? (
                                        <Grid
                                            item
                                            container
                                            className="artistOffersFromHosts"
                                        >
                                            {thisEvent.offersFromHosts
                                                .filter((e) => e) //.filter(e => e) to remove any null values
                                                .map((thisOffer, idx) => (
                                                    <ArtistDashboardBookingOffers
                                                        thisOffer={thisOffer}
                                                        thisEvent={thisEvent}
                                                        onNotificationDialogClose={
                                                            releaseNotificationFocus
                                                        }
                                                    ></ArtistDashboardBookingOffers>
                                                ))}
                                        </Grid>
                                    ) : (
                                        <></>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {thisEvent.createdBy === 'ARTIST' &&
                        thisEvent.status !== 'CONFIRMED' &&
                        thisEvent.status !== 'CANCELED' && (
                            <Grid item className="deleteBtn" size={{ xs: 1 }}>
                                <IconButton
                                    onClick={(e) =>
                                        deleteArtistEvent(thisEvent._id)
                                    }
                                    size="large"
                                    sx={{
                                        position: {
                                            xs: 'absolute',
                                            sm: 'relative',
                                        },
                                        top: { xs: '0', sm: 'auto' },
                                        right: { xs: '0', sm: 'auto' },
                                    }}
                                >
                                    <DeleteIcon></DeleteIcon>
                                </IconButton>
                            </Grid>
                        )}
                    {thisEvent.status === 'CONFIRMED' &&
                        (thisEvent.confirmedArtist === artistMe._id || //be sure this artist was the confirmedArtist
                            !thisEvent.confirmedArtist) && //some older events don't have a confirmedArtist, but if it was CONFIRMED recently it should
                        new Date(thisEvent.bookingWhen) < new Date() && ( //bookingWhen is older than today
                            <ArtistReviewsHost
                                theEvent={thisEvent}
                                onNotificationDialogClose={
                                    releaseNotificationFocus
                                }
                            ></ArtistReviewsHost>
                        )}
                    {thisEvent.status === 'CANCELED' &&
                        thisEvent.canceledDate && (
                            <Typography
                                component={'p'}
                                sx={{
                                    color: 'var(--red)',
                                    fontSize: '10px',
                                    position: 'absolute',
                                    bottom: '5px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    textAlign: 'center',
                                }}
                            >
                                Canceled on:{' '}
                                {new Date(
                                    thisEvent.canceledDate
                                ).toLocaleDateString(undefined, {
                                    // weekday: 'long',
                                    year: 'numeric',
                                    month: 'numeric',
                                    day: 'numeric',
                                    timeZone: 'UTC', //fixes timezone issues where users see the date a day off sometimes
                                })}
                            </Typography>
                        )}
                    {!showEventPageActions && (
                        <CancelEventBtnDialog
                            theEvent={thisEvent}
                            canceledBy={'ARTIST'}
                            onCancelStarted={onCancelStarted}
                        ></CancelEventBtnDialog>
                    )}
                </Grid>
            </Tooltip>
        </>
    );
};

ArtistDashboardEventCard.propTypes = {
    thisEvent: PropTypes.object.isRequired,
    artistViewedHostOffer: PropTypes.func.isRequired,
    deleteArtistEvent: PropTypes.func.isRequired,
    eventEditDrawer: PropTypes.string,
    artistMe: PropTypes.object.isRequired,
    auth: PropTypes.object,
    onCancelStarted: PropTypes.func,
};

const mapStateToProps = (state) => ({
    eventEditDrawer: state.app.eventEditDrawer,
    artistMe: state.artist.me, //currently just for the sake of checking the id against the declinedArtists' ids
    auth: state.auth,
});

//export default ArtistDashboardEventCard;
export default connect(mapStateToProps, {
    artistViewedHostOffer,
    deleteArtistEvent,
    // })(withRouter(ArtistDashboardEventCard)); //withRouter allows us to pass history objects
})(ArtistDashboardEventCard); //withRouter allows us to pass history objects
